// extracted by mini-css-extract-plugin
export default {"sideMenu":"SideMenu_sideMenu__4SYJN"};